import React from 'react';
import {  Edit,  Create, useGetOne} from 'react-admin';
import { useParams, useLocation } from 'react-router-dom';
import ProvenanceForm from './ProvenanceForm';

export const ProvenanceEdit = (props) => {
  const { id } = useParams();
  const { data: record, isLoading } = useGetOne('provenance', { id });
  
  // Extract product type from the loaded data
  // Note: useGetOne returns {data, isLoading} not {record, isLoading} - we rename data to record for clarity
  const productType = record?.data?.productType || 'wine'; // Default to wine if not specified
  return (
    <Edit {...props}>
      {!isLoading && <ProvenanceForm isEdit={true} productType={productType} />}
    </Edit>
  );
};

// Creates a new provenance record where all form fields are stored in a nested 'data' object.
// Each input with source="data.fieldName" becomes record.data.fieldName in the final submission.
export const ProvenanceCreate = props => {
  const location = useLocation();
  const type = new URLSearchParams(location.search).get('productType');
  // Throw an exception if product type is not provided
  if (!type) {
    throw new Error('Product type is required. Please specify a type parameter in the URL.');
  }

  return (
    <Create {...props} >
      <ProvenanceForm productType={type} isEdit={false} />
    </Create>
  );
}

export default ProvenanceEdit;